import {
  ActionReducerMapBuilder,
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit';
import { RootState } from '../store';
import { LoadingType } from '../../models/LoadingType';
import { startClaim } from './actions/startClaim';
import { getClaim } from './actions/getClaim';
import { Claim } from '../../models/Claim';
import { VestingClaimErrorType } from '../../models/VestingClaimErrorType';

export interface IClaimSliceState {
  claim?: Claim;
  vestingContractAddress?: string;
  loading: LoadingType;
  error?: VestingClaimErrorType;
}

export const initialState: IClaimSliceState = {
  loading: LoadingType.Idle,
  error: undefined
};

export const claimSlice = createSlice({
  name: 'claim',
  initialState,
  reducers: {
    cleanClaim: (state) => {
      state.claim = undefined;
      state.error = undefined;
    },
    updateClaim: (state, action: PayloadAction<Claim>) => {
      state.claim = action.payload;
    },
    updateClaimVestingContractAddress: (
      state,
      action: PayloadAction<{ claim: Claim; vestingContractAddress: string }>
    ) => {
      state.vestingContractAddress = action.payload.vestingContractAddress;
      state.claim = action.payload.claim;
      state.error = undefined;
    }
  },
  extraReducers: (builder: ActionReducerMapBuilder<IClaimSliceState>) => {
    builder.addCase(startClaim.fulfilled, (state, { payload }) => {
      return {
        ...state,
        claim: payload,
        loading: LoadingType.Succeeded
      };
    });
    builder.addCase(startClaim.pending, (state) => {
      state.loading = LoadingType.Pending;
    });
    builder.addCase(startClaim.rejected, (state, { payload }) => {
      state.loading = LoadingType.Failed;
      state.error = payload;
    });

    builder.addCase(getClaim.fulfilled, (state, { payload }) => {
      return {
        ...state,
        claim: payload,
        loading: LoadingType.Succeeded
      };
    });
    builder.addCase(getClaim.pending, (state) => {
      state.loading = LoadingType.Pending;
    });
    builder.addCase(getClaim.rejected, (state, { payload }) => {
      state.loading = LoadingType.Failed;
      state.error = payload;
    });
  }
});

export const selectLoading = (state: RootState): LoadingType =>
  state.claim.loading;
export const selectUnlockError = (state: RootState) => state?.claim?.error;
export const selectVestingContractAddress = (
  state: RootState
): string | undefined => state.claim.vestingContractAddress;
export const selectClaim = (state: RootState): Claim | undefined =>
  state.claim.claim;

export const claimReducer = claimSlice.reducer;
